import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 0 auto;
  padding: 0 70px;
  max-width: 1630px;
  /* overflow-x: hidden; */ // Check if we really need this prop, cause it blocks displaying of Artist Protection Program alert on desktop

  @media ${device.mobileMax} {
    padding: 0;
    overflow-x: hidden;
  }
`

export const PageTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
`

export const PageTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${colors.mainText};
`

export const BackButton = styled.img`
  padding: 10px 18px 10px 0;
  width: 30px;
  height: 30px;
  cursor: pointer;
`

export const MainContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-top: 30px;

  @media ${device.mobileMax} {
    margin-bottom: 64px;
    flex-direction: column;
  }
`

export const SetupContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  margin-right: 16px;

  @media ${device.mobileMax} {
    margin-right: 0;
    margin-bottom: 16px;
  }
`

export const ButtonsContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: none;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: ${colors.white};
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.25);

  @media ${device.mobileMax} {
    display: flex;
  }
`

export const ContinueButton = styled.button<{
  disabled?: boolean
  payment?: boolean
}>`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: ${({ payment }) => (payment ? '9.5px 40px' : '9.5px 24px')};
  width: ${({ payment }) => (payment ? 130 : 105)}px;
  height: 40px;
  background-color: ${({ disabled }) =>
    disabled ? colors.greyTextBlackBg : colors.green};
  font-size: 14px;
  color: ${colors.white};
  border-radius: 100px;
  cursor: pointer;
  white-space: nowrap;
`

export const PromoCodeButton = styled.button`
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  color: ${colors.mainText};
  border-bottom: 1px dashed ${colors.mainText};
  background-color: transparent;
  cursor: pointer;
  white-space: nowrap;
`

export const TotalContainer = styled.div`
  margin-right: 40px;
  display: flex;
  flex-direction: column;
`

export const TotalLabel = styled.span`
  font-size: 14px;
  line-height: 21px;
  font-weight: 600;
  color: ${colors.mainText};
`

export const TotalSum = styled.span`
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: ${colors.mainText};
`
export const AlertProtectionWrapper = styled.div`
  display: grid;
  grid-template-columns: 21px 1fr;
  gap: 17.5px;
  margin-top: 16px;
  border-radius: 4px;
  width: 100%;
  font-size: 14px;
  color: ${colors.greyTextWhiteBg};
`

export const AlertProtectionWrapperText = styled.div`
  display: grid;
  line-height: 21px;
  > span:first-of-type {
    font-weight: 600;
  }
`

export const SecurePaymentBlock = styled.div`
  display: grid;
  grid-template-columns: 18.14px 1fr;
  gap: 21.86px;
  margin-top: 16px;
  border-radius: 4px;
  width: 100%;
  font-size: 14px;
  color: ${colors.greyTextWhiteBg};
`

export const SecurePaymentText = styled.div`
  display: grid;
  line-height: 21px;
`

const getCardSize = (
  type: 'visa' | 'mastercard' | 'discover' | 'JCB' | 'diners'
) => {
  switch (type) {
    case 'visa':
      return `
        width: 32px;
        height: 10px;
      `
    case 'mastercard':
      return `
        width: 26px;
        height: 16px;
      `
    case 'discover':
      return `
        width: 32px;
        height: 10px;
      `
    case 'JCB':
      return `
        width: 22px;
        height: 10px;
      `
    case 'diners':
      return `
        width: 24px;
        height: 10px;
      `
    default:
      return ``
  }
}

export const ContainerPayment = styled.div`
  display: flex;
  flex-direction: column;
  padding: 33.5px 24px;
  width: 100%;
  background: ${colors.white};
  border-radius: 4px;
  margin-bottom: 16px;
`

export const CartDeliveriesWrapper = styled.div`
  padding: 9.5px 0px 11.5px 0px;
  margin-bottom: 0px;
`

export const WrapperDivMargin = styled.div`
  margin-bottom: 13px;
`
export const CardsImgWraper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

export const RadioLabelContainer = styled.div`
  display: flex;
  flex-direction: row;

  @media ${device.mobileMax} {
    flex-direction: column;

    ${CardsImgWraper} {
      margin-top: 5px;
      margin-left: -24px;
    }
  }
`

export const StyledSpan = styled.span<{ isInner?: boolean }>`
  font-size: ${({ isInner }) => (isInner ? 14 : 18)}px;
  margin-right: 32px;
  display: flex;
  align-items: center;
  color: ${colors.mainText};
  line-height: 27px;
  font-weight: 400;
  white-space: break-spaces;
`

export const StyledImgWrapper = styled.div`
  width: 151px;
`

export const CardImg = styled.img<{
  type: 'visa' | 'mastercard' | 'discover' | 'JCB' | 'diners'
}>`
  display: flex;
  align-items: center;
  padding: 4px;
  width: 40px;
  height: 24px;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  margin-right: 8px;
  ${({ type }) => getCardSize(type)}
  width: 40px;
  height: 24px;
`

export const VisaWraper = styled.div`
  display: flex;
  align-items: center;
  width: 40px;
  height: 24px;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  margin-right: 8px;
  & img {
    width: 32px;
    height: 10px;
  }
`
export const MasterCardWraper = styled.div`
  display: flex;
  align-items: center;
  width: 40px;
  height: 24px;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  margin-right: 8px;
  & img {
    width: 26px;
    height: 16px;
  }
`
export const DiscoverWraper = styled.div`
  display: flex;
  align-items: center;
  width: 40px;
  height: 24px;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  margin-right: 8px;
  & img {
    width: 32px;
    height: 10px;
  }
`

export const JCBWraper = styled.div`
  display: flex;
  align-items: center;
  width: 40px;
  height: 24px;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  margin-right: 8px;
  & img {
    width: 22px;
    height: 16px;
  }
`

export const DinersWraper = styled.div`
  display: flex;
  align-items: center;
  width: 40px;
  height: 24px;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  & img {
    width: 24px;
    height: 16px;
  }
`

export const Label = styled.label`
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: ${colors.mainText};
`

export const InputContainerForBluesnap = styled.div`
  flex: 1;
  height: 47px;
`

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  height: 76px;
  flex: 1;
`

export const Input = styled.input`
  padding: 13px 16px;
  flex: 1;
  height: 47px;
  font-size: 14px;
  line-height: 21px;
  color: ${colors.mainText};
  border: 1px solid ${colors.greyStroke};
  border-radius: 8px;
  outline: none;
`
export const InputRow = styled.div`
  display: flex;
  flex-direction: row;
`

export const RowDivider = styled.div`
  width: 16px;
`

export const PaypalContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
`

export const BuyNowPayLater = styled.span`
  margin-top: 8px;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: ${colors.black};
`

export const BluesnapErrorContainer = styled.div`
  margin-bottom: 10px;
`
export const ContinueButtonPaypal = styled.button<{ disabled?: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 9.5px 40px;
  width: 100%;
  height: 40px;
  background-color: ${({ disabled }) =>
    disabled ? colors.greyTextBlackBg : colors.green};
  font-size: 14px;
  color: ${colors.white};
  border-radius: 100px;
  cursor: pointer;
  pointer-events: none;
  position: absolute;
  white-space: nowrap;
`

export const PaypalButtonWrapper = styled.button`
  flex: 1;
  padding: 0;
  background-color: transparent;
  position: relative;
  height: 40px;
`

export const CardForm = styled.div`
  margin-top: 19.5px;
  position: relative;
`

export const PaymentTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
`

export const CardFormLoading = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.4);
`
export const HiddenContentWrapper = styled.div<{ active?: boolean }>`
  display: ${({ active }) => (active ? 'flex' : 'none')};
`
export const StepTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${colors.mainText};
  line-height: 150%;
  margin-bottom: 14px;
`
